<template>
    <div class="container-fluid mt-5">
        <div>
        <card
            class="no-border-card"
            body-classes="px-0 pb-1"
            footer-classes="pb-2"
        >
            <template slot="header">
                <div class="row">
                    <div class="col-7 d-flex">
                        <h3 class="mb-0 mr-3">Reporte de Salidas y Servicios</h3>
                        <base-button class="hover-apolo inline-block" type="default" icon size="sm" @click="reload()">
                        <span class="btn-inner--icon"
                            ><i class="fas fa-redo"></i
                        ></span>
                        </base-button>
                    </div>
                    <div class="col-5 text-right">
                        <base-button class="hover-apolo" type="default" icon size="sm" @click="downloadReport()">
                        <span class="btn-inner--icon"
                            ><i class="fas fa-download"></i
                        ></span>
                        <span class="btn-inner--text">Descargar Reporte</span>
                        </base-button>
                    </div>
                </div>
            </template>
            <div>
            <div
                class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap mb-3"
            >   
                <date-picker
                  class="col-2"
                  placeholder="Fecha inicio"
                  v-model="fecha_inicio"
                  :format="'DD-MM-YYYY'"
                  :lang="'es'"
                ></date-picker>
                <date-picker
                  class="col-2"
                  placeholder="Fecha fin"
                  v-model="fecha_fin"
                  :format="'DD-MM-YYYY'"
                  :lang="'es'"
                ></date-picker>
                <multiselect class="col-3" v-model="terminal_origen" :options="terminales" :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Selecccionar origen" :custom-label="nombreAbreviatura" track-by="id" :showLabels="false"></multiselect>
                <multiselect class="col-3" v-model="terminal_destino" :options="terminales" :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Selecccionar destino" :custom-label="nombreAbreviatura" track-by="id" :showLabels="false"></multiselect>
            </div>
            <pulse-loader class="text-center" v-if="loadingSpinner" :loading="loadingSpinner" :color="color" :size="size"></pulse-loader>
            <div style="overflow-x: scroll; width: auto;"> 
                <el-table
                    class="table-responsive align-items-center table-flush"
                    header-row-class-name="thead-light"
                    :data="reportes"
                    @sort-change="sortChange"
                >
                    <div slot="empty" v-if="loading">
                    <img src="/img/loading.gif" style="height: 100px; width: 100px" />
                    </div>
    
                    <div slot="empty" v-if="reportes">
                    Sin datos disponibles
                    </div>
    
                    <el-table-column label="#" prop="attributes.id" min-width="110px" sortable/>
                    <el-table-column label="Terminal Origen" prop="attributes.terminal_origen" min-width="190px" sortable/>
                    <el-table-column label="Terminal Destino" prop="attributes.terminal_destino" min-width="200px" sortable/>
                    <el-table-column label="Fecha y hora salida" min-width="220px" prop="attributes.fecha_hora_salida" sortable>
                        <div slot-scope="{ row }">
                        <span v-if="row.attributes.fecha_hora_salida">{{row.attributes.fecha_hora_salida | moment('DD-MM-YYYY hh:mm')}}</span>
                        <span v-else> </span>
                        </div>
                    </el-table-column>
                    <el-table-column label="Bus" prop="attributes.numero_economico" min-width="110px" sortable/>
                    <el-table-column label="Total venta" min-width="160px" prop="attributes.total_ventas">
                        <div slot-scope="{ row }">
                        <span v-if="row.attributes.monto_total_ventas">${{row.attributes.monto_total_ventas}}</span>
                        <span v-else>$0.00</span>
                        </div>
                    </el-table-column>
                    <el-table-column label="Disponibilidad" min-width="180px" prop="attributes.disponibilidad">
                        <div slot-scope="{ row }">
                        <span v-if="row.attributes.disponibilidad">{{row.attributes.disponibilidad}}</span>
                        <span v-else> </span>
                        </div>
                    </el-table-column>
                    <el-table-column label="Capacidad Bus" min-width="190px" prop="attributes.capacidad">
                        <div slot-scope="{ row }">
                        <span v-if="row.attributes.capacidad">{{row.attributes.capacidad}}</span>
                        <span v-else> </span>
                        </div>
                    </el-table-column>
                    <el-table-column label="Layout" prop="attributes.layout" min-width="130px"/>
                    <el-table-column align="center" min-width="400px">
                        <div slot-scope="{ row }" class="table-actions">
                            <base-button :disabled="loadingSpinner" class="hover-apolo" type="primary" icon size="sm" @click="ventasModal(row)">
                                <span class="btn-inner--text">Ventas</span>
                            </base-button>
                            <base-button class="hover-apolo" type="primary" icon size="sm" @click="listaAbordajeModal(row)">
                                <span class="btn-inner--text">Lista de abordaje</span>
                            </base-button>
                            <base-button class="hover-apolo" type="primary" icon size="sm" @click="verTripulacionModal(row)">
                                <span class="btn-inner--text">Tripulación</span>
                            </base-button>
                        </div>
                    </el-table-column>
                </el-table>
            </div>
            </div>
            <div
            slot="footer"
            class="col-12"
            >
            <el-select
                class="select-primary pagination-select"
                v-model="pagination.perPage"
                placeholder="Datos por página"
                >
                <el-option
                    class="select-primary"
                    v-for="item in pagination.perPageOptions"
                    :key="item.value"
                    :label="item.descripcion"
                    :value="Number(item.value)"
                >
                </el-option>
            </el-select>
            <div class="justify-content-center d-flex flex-wrap">
                <base-pagination
                class="pagination-no-border"
                v-model="pagination.currentPage"
                :per-page="pagination.perPage"
                :total="total"
            />
            </div>
            
            </div>
        </card>
        </div>
        <!-- MODAL VER VENTAS -->
        <modal :show.sync="showVentas" modal-classes="modal-primary" size="xl">
            <h6 slot="header" class="mb-0 modal-title">Análisis de venta por servicio</h6>
            <form v-if="ventas != null" class="new-event--form" @submit.prevent="">
                <div class="row">
                    <div class="col-3">
                        <span>Corrida: </span><span style="font-weight: 300;">{{ventas.id}}</span>
                    </div>
                    <div class="col-3">
                        <span>Ruta: </span><span style="font-weight: 300;">{{ventas.nombre_ruta}}</span>
                        
                    </div>
                    <div class="col-3">
                        <span>No. Bus: </span><span style="font-weight: 300;">{{ventas.numero_economico}}</span>
                    </div>
                    <div class="col-3">
                        <span>Conductor 1: </span><span style="font-weight: 300;">{{ventas.operador1}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-3">
                        <span>Origen: </span><span style="font-weight: 300;">{{ventas.terminal_origen}}</span>
                    </div>
                    <div class="col-3">
                        <span>Fecha de salida: </span><span style="font-weight: 300;">{{ventas.fecha_hora_salida | moment('DD-MM-YYYY')}}</span>
                    </div>
                    <div class="col-3">
                        <span>Layout: </span><span style="font-weight: 300;">{{ventas.layout}}</span>
                    </div>
                    <div class="col-3">
                        <span>Conductor 2: </span><span style="font-weight: 300;">{{ventas.operador2}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-3">
                        <span>Destino: </span><span style="font-weight: 300;">{{ventas.terminal_destino}}</span>
                    </div>
                    <div class="col-3">
                        <span>Hora de salida: </span><span style="font-weight: 300;">{{ventas.fecha_hora_salida | moment('HH:mm')}}</span>
                    </div>
                    <div class="col-6">
                        <span></span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <div class="mt-4 text-left ml-0" style="font-size: 16px;"><span>Planillas</span></div>
                        <el-table
                            class="table-responsive align-items-center table-flush mt-3"
                            header-row-class-name="thead-light"
                            :data="ventas.planillas"
                            >
                            <div slot="empty" v-if="loading">
                                <img src="/img/loading.gif" style="height: 100px; width: 100px" />
                            </div>
                
                            <div slot="empty" v-if="ventas">
                                Sin datos disponibles
                            </div>
                            
                            <el-table-column label="Ciudad" prop="ciudad" />
                            <el-table-column label="Pasajes" prop="cantidad_boletos" />
                            <el-table-column label="Valor" prop="total_agencia">
                                <div slot-scope="{ row }">
                                    <span v-if="row.total_agencia">${{row.total_agencia}}</span>
                                    <span v-else>$0.00</span>
                                </div>
                            </el-table-column>
                        </el-table>
                        <div class="mt-3 text-left ml-0" style="font-size: 16px;"><span>Ventas por Agencia</span></div>
                        <el-table
                            class="table-responsive align-items-center table-flush mt-3"
                            header-row-class-name="thead-light"
                            :data="ventas.ventas_agencia"
                            default-expand-all
                            >
                            <div slot="empty" v-if="loading">
                                <img src="/img/loading.gif" style="height: 100px; width: 100px" />
                            </div>
                
                            <div slot="empty" v-if="ventas">
                                Sin datos disponibles
                            </div>

                            <el-table-column type="expand">
                                <template #default="props">

                                    <el-table v-if="props.row.subcorridas.length > 0" :data="props.row.subcorridas" >
                                        <el-table-column label="Ruta" prop="tramo_subcorrida" />
                                        <el-table-column label="Pasaje"prop="boletos_tramo" />
                                        <el-table-column label="Valor" prop="total_tramo">
                                            <div slot-scope="{ row }">
                                                <span v-if="row.total_tramo">${{row.total_tramo}}</span>
                                                <span v-else>$0.00</span>
                                            </div>
                                        </el-table-column>
                                    </el-table>
                                </template>
                            </el-table-column>
                            <el-table-column label="Agencia" prop="agencia_nombre" />
                            <el-table-column label="Pasajes Total" prop="total_boletos" />
                            <el-table-column label="Valor Total" prop="total_agencia">
                                <div slot-scope="{ row }">
                                    <span v-if="row.total_agencia">${{row.total_agencia}}</span>
                                    <span v-else>$0.00</span>
                                </div>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="col-6">
                        <div class="mt-4 text-left ml-0 mb-3" style="font-size: 16px;"><span>Cantidad de boletos vendidos por tramo</span></div>
                        <bar-chart
                            :chart-data="chartDataTramo"
                            :height="350"
                            :extra-options="chartOptions"
                            v-if="loaded"
                        />
                        <div class="mt-3 text-left ml-0 mb-3" style="font-size: 16px;"><span>Cantidad de boletos vendidos por hora</span></div>
                        <bar-chart
                            :chart-data="chartDataHora"
                            :height="350"
                            :extra-options="chartOptions"
                            v-if="loaded"
                        />
                        <div class="mt-3 text-left ml-0 mb-3" style="font-size: 16px;"><span>Cantidad de boletos vendidos por día</span></div>
                        <bar-chart
                            :chart-data="chartDataDia"
                            :height="350"
                            :extra-options="chartOptions"
                            v-if="loaded"
                        />
                    </div>
                </div>
               
                <input type="hidden" class="new-event--start"/>
                <input type="hidden" class="new-event--end"/>
            </form>
    
            <template slot="footer">
                <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="close()">Cerrar</button>
            </template>
        </modal>
        <!-- MODAL VER LISTA DE ABORDAJE -->
        <modal :show.sync="showListaAbordajeModal" :close-on-backdrop="true" :hasParent="true" modal-classes="modal-primary" size="lg">
            <div class="row">
            <h6 slot="header" class="mb-0 modal-title col-6">Lista de abordaje de corrida</h6>
            <button class="btn btn-default hover-apolo new-event--add ml-2 col-4" align="right" @click="imprimirListaAbordaje()">Imprimir</button>
            </div>
            <form class="new-event--form">
            <span v-if="TotalVentaCorrida != null">Total de venta corrida: ${{ TotalVentaCorrida }}</span>
            <br>
            <el-table
                class="table-responsive align-items-center table-flush"
                header-row-class-name="thead-light"
                :data="listaAbordaje"
                @sort-change="sortChange"
                >
                <div slot="empty" v-if="loading">
                    <img src="/img/loading.gif" style="height: 100px; width: 100px" />
                </div>
    
                <div slot="empty" v-if="listaAbordaje">
                    Sin datos disponibles
                </div>
    
                <el-table-column label="Asiento" prop="attributes.numero" width="100px"/>
                <el-table-column label="Categoría" prop="attributes.categoria.nombre" width="150px"/>
                <el-table-column label="Pasajero">
                    <div slot-scope="{ row }" class="table-actions">
                    <div v-if="row.attributes.pasajeros">
                        <div v-for="(pasajero, index) in row.attributes.pasajeros" :key="pasajero.id">
                        <span>{{pasajero}}</span> 
                        </div>
                    </div>
                    <div v-else>
                        <span>Sin Boletos</span>
                    </div>
                    </div> 
                </el-table-column>
                <el-table-column label="Sube">
                    <div slot-scope="{ row }" class="table-actions">
                    <div v-if="row.attributes.pasajeros">
                        <div v-for="(pasajero, index) in row.attributes.pasajeros" :key="pasajero.id">
                        <span>{{ row.attributes.sube[index] }}</span> 
                        </div>
                    </div>
                    <div v-else>
                        <span>-</span>
                    </div>
                    </div> 
                </el-table-column>
                <el-table-column label="Baja">
                    <div slot-scope="{ row }" class="table-actions">
                    <div v-if="row.attributes.pasajeros">
                        <div v-for="(pasajero, index) in row.attributes.pasajeros" :key="pasajero.id">
                        <span>{{ row.attributes.baja[index] }}</span> 
                        </div>
                    </div>
                    <div v-else>
                        <span>-</span>
                    </div>
                    </div> 
                </el-table-column>
                <el-table-column label="Valor Boleto">
                    <div slot-scope="{ row }" class="table-actions">
                    <div v-if="row.attributes.valor_venta_boleto">
                        <div v-for="(valor, index) in row.attributes.valor_venta_boleto" :key="valor.id">
                        <span>{{valor}}</span> 
                        </div>
                    </div>
                    <div v-else>
                        <span>-</span>
                    </div>
                    </div> 
                </el-table-column>
                <el-table-column label="Descuento">
                <div slot-scope="{ row }" class="table-actions">
                    <div v-if="row.attributes.detalles_descuento">
                        <div v-for="(valor, index) in row.attributes.detalles_descuento" :key="valor.id">
                        <span>{{valor}}</span> 
                        </div>
                    </div>
                    <div v-else>
                        <span>-</span>
                    </div>
                    </div> 
                </el-table-column>
            </el-table>
            <input type="hidden" class="new-event--start"/>
            <input type="hidden" class="new-event--end"/>
            </form>
    
            <template slot="footer">
            <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="showListaAbordajeModal = false">Cerrar</button>
            </template>
        </modal>
        <!-- MODAL VER TRIPULACION -->
        <modal :show.sync="showTripulacion" modal-classes="modal-primary" size="lg">
            <h6 slot="header" class="mb-0 modal-title">Ver Tripulación</h6>
            <form v-if="tripulacion != null" class="new-event--form" @submit.prevent="">
                <div class="row">
                    <div class="col-6">
                        <span>Corrida: </span><span style="font-weight: 300;">{{tripulacion.id}}</span>
                    </div>
                    <div class="col-6">
                        <span>Ruta: </span><span style="font-weight: 300;">{{tripulacion.attributes.nombre_ruta}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <span>Origen: </span><span style="font-weight: 300;">{{tripulacion.attributes.terminal_origen}}</span>
                    </div>
                    <div class="col-6">
                        <span>Fecha de salida: </span><span style="font-weight: 300;">{{tripulacion.fecha_hora_salida | moment('DD-MM-YYYY')}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <span>Destino: </span><span style="font-weight: 300;">{{tripulacion.attributes.terminal_destino}}</span>
                    </div>
                    <div class="col-6">
                        <span>Hora de salida: </span><span style="font-weight: 300;">{{tripulacion.attributes.fecha_hora_salida | moment('HH:mm')}} hrs</span>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-4">
                        <span>Bus: </span><span style="font-weight: 300;">{{tripulacion.attributes.numero_economico}}</span>
                    </div>
                    <div class="col-4">
                        <span>Asientos: </span><span style="font-weight: 300;">{{tripulacion.attributes.numero_asientos}}</span>
                    </div>
                    <div class="col-4">
                        <span>Layout: </span><span style="font-weight: 300;">{{tripulacion.attributes.layout}}</span>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-12">
                        <span v-if="tripulacion.attributes.operador1">Conductor 1: <span style="font-weight: 300;">{{tripulacion.attributes.operador1}}</span></span>
                        <span v-else>Conductor 1: <span style="font-weight: 300;">Sin conductor asignado</span></span>
                    </div>
                    <div class="col-12">
                        <span v-if="tripulacion.attributes.operador2">Conductor 2: <span style="font-weight: 300;">{{tripulacion.attributes.operador2}}</span></span>
                        <span v-else>Conductor 2: <span style="font-weight: 300;">Sin conductor asignado</span></span>
                    </div>
                </div>
                <input type="hidden" class="new-event--start"/>
                <input type="hidden" class="new-event--end"/>
            </form>
    
            <template slot="footer">
                <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="close()">Cerrar</button>
            </template>
        </modal>
    </div>
    </template>
    <script>
    import Vue from 'vue';
    import Multiselect from 'vue-multiselect';
    import formMixin from "@/mixins/form-mixin";
    import ValidationError from "@/components/ValidationError.vue";
    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';
    import { BasePagination, Modal, BaseSwitch } from "@/components/";
    import {
    Table,
    TableColumn,
    DropdownMenu,
    DropdownItem,
    Dropdown,
    Tooltip,
    Select,
    Option,
    RadioButton,
    Button,
    } from "element-ui";
    import swal from "sweetalert2";
    import "sweetalert2/dist/sweetalert2.css";
    import { throws } from 'assert';
    import {Impresora} from "@/printer/Impresora.js";
    import ImpresionListaAbordaje from "./ImpresionListaAbordaje.vue";
    import BarChart from '@/components/Charts/BarChart';
    import PulseLoader from 'vue-spinner/src/PulseLoader.vue';
    
    export default {
    layout: "DashboardLayout",
    
    components: {
        ValidationError,
        Modal,
        Multiselect,
        DatePicker,
        BaseSwitch,
        BasePagination,
        [Tooltip.name]: Tooltip,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Dropdown.name]: Dropdown,
        [DropdownItem.name]: DropdownItem,
        [DropdownMenu.name]: DropdownMenu,
        [Select.name]: Select,
        [Option.name]: Option,
        [Button.name]: Button,
        BarChart,
        PulseLoader
    },
    
    mixins: [formMixin],
    
    data() {
        return {
            reportes: [],
            ventas: [],
            listaAbordaje: [],
            corrida_abordaje: null,
            tripulacion: null,
            fecha_inicio: null,
            fecha_fin: null,
            terminal_origen: null,
            terminal_destino: null,
    
            sort: "fecha_hora_salida",
    
            pagination: {
                perPage: 5,
                currentPage: 1,
                perPageOptions: [{value:'5', descripcion: '5 boletos por página'},
                {value:'10', descripcion: '10 boletos por página'},
                {value:'25', descripcion: '25 boletos por página'},
                {value:'50', descripcion: '50 boletos por página'}],
            },
            total: 0,
            loading: true,
            reporte: {
                type: "reporte",
                fecha_inicio: null,
                fecha_fin: null,
                usuario_id: null
            },
            terminales: [],
            showVentas: false,
            showTripulacion: false,
            showListaAbordajeModal: false,
            params: null,
            chartDataTramo: {
                labels: [],
                datasets: [ { data: [] } ]
            },
            chartDataHora: {
                labels: [],
                datasets: [ { data: [] } ]
            },
            chartDataDia: {
                labels: [],
                datasets: [ { data: [] } ]
            },
            chartOptions: {
                responsive: true,
                indexAxis: 'y'
            },
            loaded: false,
            loadingSpinner: false,
            color: '#0068a0',
            size: '30px',
            TotalVentaCorrida: null
        };
    },
    
    computed: {
        from() {
            return this.pagination.perPage * (this.pagination.currentPage - 1);
        },
    
        to() {
            let highBound = this.from + this.pagination.perPage;
            if (this.total < highBound) {
                highBound = this.total;
            }
            return highBound;
        }
    },
    
    watch: {
        fecha_inicio: {
            handler: "getListDebounced",
            immediate: false,
        },
        fecha_fin: {
            handler: "getListDebounced",
            immediate: false,
        },
        terminal_origen: {
            handler: "getListDebounced",
            immediate: false,
        },
        terminal_destino: {
            handler: "getListDebounced",
            immediate: false,
        },
        pagination: {
            handler: "getList",
            immediate: false,
            deep: true,
        },
    },
    
    created(){
        this.prueba = true;
        this.getTerminales();
    },
    
    async mounted(){
        this.fecha_fin = new Date(),
        this.fecha_inicio = new Date((this.fecha_fin.getMonth()+1)+' '+'1'+' '+this.fecha_fin.getFullYear());
    },
    
    methods: {
        reload(){
            this.$router.go(this.$router.currentRoute)
        },
        getListDebounced: _.debounce(function () {
            this.getList();
        }, 300),
    
        async getList() {
            var fecha_inicio_format = null;
            var fecha_fin_format = null;
            if(this.fecha_inicio != null){
                var fecha_inicio = this.fecha_inicio;
                fecha_inicio_format = fecha_inicio.getFullYear()  + "-" + ("0"+(fecha_inicio.getMonth()+1)).slice(-2) + "-" + ("0" + fecha_inicio.getDate()).slice(-2);
            }
            if(this.fecha_fin != null){
                var fecha_fin = this.fecha_fin;
                var fecha_hora = new Date(new Date().setHours(23,59,59,0));
                fecha_fin_format = fecha_fin.getFullYear()  + "-" + ("0"+(fecha_fin.getMonth()+1)).slice(-2) + "-" + ("0" + fecha_fin.getDate()).slice(-2);
            }
            if(fecha_inicio_format != null && fecha_fin_format != null){
                if(fecha_inicio_format > fecha_fin_format){
                    this.$notify({
                        type: "danger",
                        message: "La fecha fin debe ser mayor que la fecha inicio",
                        duration: -1
                    });
                    return;
                }
            }

            let params = {
                ...(this.sort ? { sort: this.sort } : {}),
                filter: {
                //...(this.search ? { search: this.search } : {}),
                ...(this.terminal_origen ? { terminal_origen_id: this.terminal_origen.id } : {}),
                ...(this.terminal_destino ? { terminal_destino_id: this.terminal_destino.id } : {}),
                ...({ fecha_inicio: fecha_inicio_format }),
                ...( { fecha_fin: fecha_fin_format }),
                },
                page: {
                    number: this.pagination.currentPage,
                    size: this.pagination.perPage,
                },
            };
            this.params = {
                ...(this.sort ? { sort: this.sort } : {}),
                filter: {
                //...(this.search ? { search: this.search } : {}),
                ...(this.terminal_origen ? { terminal_origen_id: this.terminal_origen.id } : {}),
                ...(this.terminal_destino ? { terminal_destino_id: this.terminal_destino.id } : {}),
                ...({ fecha_inicio: fecha_inicio_format }),
                ...( { fecha_fin: fecha_fin_format }),
                }
            };
            await this.$store.dispatch("reporte_salidas/list", params).then(() => {
                this.reportes = this.$store.getters["reporte_salidas/list"];
                this.total = this.$store.getters["reporte_salidas/listTotal"];
            });
            this.loading = false;
        },

        async getTerminales() {
            let params = {
            filter: {
            },
            page: {
                number: 1,
                size: 100000,
            },
            };
            await this.$store.dispatch("terminales/list", params).then(() => {
                this.terminales = this.$store.getters["terminales/list"];
            });
        },

        nombreAbreviatura ({ nombre, abreviatura }) {
            return `${nombre} (${abreviatura})`
        },
    
        close(){
            if(this.showHistorial == true){
                this.showHistorial = false;
            }
            if(this.showTripulacion == true){
                this.showTripulacion = false;
            }
            if(this.showVentas == true){
                this.showVentas = false;
                this.loaded = false;
            }
        },

        async downloadReport(){
            await this.$store.dispatch("reporte_salidas/getReporte", this.params).then(() => {
            });
        },

        async ventasModal($boleto){
            this.loadingSpinner = true;
            this.ventas = $boleto.attributes;
            let analisis = null;
            await this.$store.dispatch("reporte_salidas/getVentaPorCorrida", $boleto.id).then(() => {
                analisis = this.$store.getters["reporte_salidas/getVentaPorCorrida"];
            });
            this.ventas.planillas = analisis.ciudad;
            // Calcular sumatorias
            if(this.ventas.planillas.length > 1){
                const totalPasajes = this.ventas.planillas.reduce((sum, row) => sum + row.cantidad_boletos, 0);
                const totalValor = this.ventas.planillas.reduce((sum, row) => sum + row.total_agencia, 0);
                this.ventas.planillas.push({
                    ciudad_id: null,
                    ciudad: "Total",
                    cantidad_boletos: totalPasajes,
                    total_agencia: totalValor
                });
            }
            this.ventas.ventas_agencia = analisis.agencia_tramo;
            // Calcular sumatorias
            if(this.ventas.ventas_agencia.length > 1){
                const totalBoletos = this.ventas.ventas_agencia.reduce((sum, row) => sum + row.total_boletos, 0);
                const totalAgencias = this.ventas.ventas_agencia.reduce((sum, row) => sum + row.total_agencia, 0);
                // Agregar fila "Total"
                this.ventas.ventas_agencia.push({
                    agencia_nombre: "Total",
                    total_boletos: totalBoletos,
                    total_agencia: totalAgencias,
                    subcorridas: []
                });
            }
            this.chartDataTramo.labels = Object.keys(analisis.tramo_subcorrida);
            this.chartDataTramo.datasets[0].data = Object.values(analisis.tramo_subcorrida);
            this.chartDataHora.labels = Object.keys(analisis.hora);
            this.chartDataHora.labels = (this.chartDataHora.labels).map(value => value+" hrs");
            this.chartDataHora.datasets[0].data = Object.values(analisis.hora);
            this.chartDataDia.labels = Object.keys(analisis.dia_semana);
            this.chartDataDia.datasets[0].data = Object.values(analisis.dia_semana);
            this.loaded = true;
            this.showVentas = true;
            this.loadingSpinner = false;
        },

        async listaAbordajeModal($corrida){
            await this.$store.dispatch("corridas/listAbordaje", $corrida.id).then(() => {
                this.listaAbordaje = this.$store.getters["corridas/listAbordaje"];
            });
            await this.$store.dispatch("corridas/getTotalVentaCorrida", $corrida.id).then(() => {
                this.TotalVentaCorrida = this.$store.getters["corridas/getTotalVentaCorrida"];
            });
            this.corrida_abordaje = $corrida;
            this.showListaAbordajeModal = true;
        },

        verTripulacionModal(data){
            this.tripulacion = data;
            this.showTripulacion = true;
        },

        async imprimirListaAbordaje(){
            //se obtienen datos de usuario autenticado
            let me = await this.$store.getters["profile/me"];
            // imagen a base64
            const getBase64FromUrl = async (url) => {
                const data = await fetch(url);
                const blob = await data.blob();
                return new Promise((resolve) => {
                const reader = new FileReader();
                reader.readAsDataURL(blob); 
                reader.onloadend = () => {
                    const base64data = reader.result;   
                    resolve(base64data);
                }
                });
            }
            let imagen = await getBase64FromUrl('/img/logoPrinter2.png');
            let printer = new Impresora;
            let tablaClass = Vue.extend(ImpresionListaAbordaje);
            let tablaInstancia = new tablaClass({
                propsData: { 
                    lista: this.listaAbordaje,
                    user: me.attributes,
                    corrida: this.corrida_abordaje 
                }
            });
            let tabla_html = (tablaInstancia.$mount().$el.outerHTML).toString();
            let tabla = this.changeSimbol(tabla_html);
            printer.setAlign("center");
            printer.imagen(imagen);
            printer.setAlign("left");
            printer.html(tabla);
            printer.cut();
            printer.end().then(respuesta => {
                console.log(respuesta);
            });
        },

        changeSimbol(s) {
            var accent_map = {'á':'a', 'é':'e', 'è':'e', 'í':'i','ó':'o','ú':'u','Á':'a', 'É':'e', 'è':'e', 'Í':'i','Ó':'o','Ú':'u', 'Ñ':'N', 'ñ':'n'};
            if (!s) { return ''; }
            var ret = '';
            for (var i = 0; i < s.length; i++) {
                ret += accent_map[s.charAt(i)] || s.charAt(i);
            }
            return ret;
        },

        sortChange({ prop, order }) {
            if (order === "descending") {
                this.sort = `-${prop.replace('attributes.', '')}`;
            } else {
                this.sort = `${prop.replace('attributes.', '')}`;
            }
            this.getList();
        },
    },
    };
    </script>
    <style>
    .linkFactura{
        color: blue;
        cursor: pointer;
    }
    .multiselect__select{
        right: 10px !important;
    }
    .el-table .sort-caret.ascending {
        border-bottom-color: #C0C4CC !important;
    }
    </style>